Pixlee.module('SinglePhotoApp', function(SinglePhotoApp, _App, _Backbone, _Marionette, _$) {
    SinglePhotoApp.on("start", function(options) {
        new SinglePhotoApp.Show.Controller(options);
    });
});
